module.exports = __webpack_public_path__ + "static/media/place-accent-light.bccd9448.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/place-accent-light.svg
// module id = 703
// module chunks = 0